// @flow
import addResourceAnnotations from 'app/packages/trace-logger/utils/addResourceAnnotations';
import Stopwatch from 'app/packages/trace-logger/Stopwatch';

const createImageStopwatch = ({
  metricName,
  coexistId,
  resourceTiming,
}: {
  metricName: string,
  coexistId: string,
  resourceTiming: PerformanceResourceTiming,
}) => {
  const { startTime, responseEnd } = resourceTiming;
  const { navigationStart } = window.performance.timing;
  // create subspan
  const stopwatch = new Stopwatch({
    name: 'image',
    metricName,
    coexistId,
    startTime: navigationStart + startTime,
    endTime: responseEnd ? navigationStart + responseEnd : 0,
  });
  if (responseEnd) {
    addResourceAnnotations(stopwatch, resourceTiming);
  }
  return stopwatch;
};

export default createImageStopwatch;
